import React, { useContext, PropsWithChildren } from "react";

interface ConditionalContextRenderProps {
  render?: Function;
}

export const ConditionalContextRender = <T=any>(context: React.Context<T>, condition: (data: T) => any) => {
    const Condition = ({ render, children }: PropsWithChildren<ConditionalContextRenderProps>) => {
        const data = useContext(context);
        return condition(data) ? (render ? render(data) : children) : null;
    };

    return Condition;
};
